import React, { useEffect, useState, useRef } from "react";
import "../styles/inviteFriendsModal.css";
import { useUserRedux } from "../../../hooks/useUserRedux";
import ModalBackground from "../../../shared/components/ModalBackground";
import { startAppLink } from "../../../shared/utils/telegramLinks";
import { useTranslation } from "react-i18next";

export default function InviteFriendsModal({ onClose }) {
  const { t } = useTranslation();
  const { data: user } = useUserRedux();           // ➜ { id, … }
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  // Build the referral link once.
  // Use Telegram ID (long) so the backend can look up the referrer by telegram_id.
  // Telegram passes the `startapp` value as `start_param` in initData.
  const telegramId = window.Telegram?.WebApp?.initDataUnsafe?.user?.id ?? user.telegramId;
  const link = startAppLink(telegramId);

  useEffect(() => {
    // Trigger slide-up animation
    setVisible(true);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);           // wait for slide-down
  };

  /** Native / Telegram share */
  const handleShare = async () => {
    try {
      // 1) Telegram WebApp shareLink (if inside Telegram)
      if (window.Telegram?.WebApp?.shareLink) {
        await window.Telegram.WebApp.shareLink(link);
        return;
      }

      // 2) Standard Web Share API
      if (navigator.share) {
        await navigator.share({
          title: t('invite.share_title', 'Join me in DATUM!'),
          text: t('invite.share_text', 'Let’s play together and get rewards 👾'),
          url: link,
        });
        return;
      }

      // 3) Fallback – just copy
      await copyLink();
    } catch (err) {
      console.error("Share failed:", err);
      await copyLink();                 // fallback if user cancels share
    }
  };

  /** Copy to clipboard + toast */
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Clipboard failed:", err);
      alert(t('invite.copy_failed', 'Could not copy link – please copy it manually:') + '\n' + link);
    }
  };

  return (
    <div className="purchase-modal-overlay" onClick={handleClose}>
      <div className={`purchase-card ${visible ? "visible" : ""}`}>
        <div
          className={`invite-modal-sheet ${visible ? "visible" : ""}`}
          onClick={(e) => e.stopPropagation()} // keep modal open on inner clicks
        >
          <div className="purchase-modal-header" style={{ position: 'relative'}}>
            <ModalBackground />
            <h2 className="purchase-modal-title" style={{ position: 'relative', zIndex: 1 }}>{t('invite.title', 'Invite a Friend')}</h2>
            <img
              className="purchase-modal-close"
              src="/close.png"
              onClick={handleClose}
              alt="Close"
              style={{ position: 'absolute', zIndex: 1 }}
            />
          </div>

          {/* buttons */}
          <div className="purchase-modal-buttons">
            <button className="app-btn app-btn--purple" onClick={handleShare}>
              {t('invite.send', 'Send')}
            </button>
            <button className="app-btn app-btn--blue" onClick={copyLink}>
              {t('invite.copy_link', 'Copy Link')}
            </button>
          </div>

          {copied && <span className="copy-toast">{t('common.copied', 'Copied!')}</span>}
        </div>
      </div>
    </div>
  );
}
